import React from 'react';

function Clock({ color = 'text-shuttle-grey', size = 'w-4 h-4' }) {
	return (
		<div className={`fill-current ${color} ${size} mr-2`}>
			<svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
				<title>flat/clock</title>
				<g id="Icons---monochrome" stroke="none" strokeWidth="1" fillRule="evenodd">
					<rect id="box" fillOpacity="0" x="0" y="0" width="16" height="16" />
					<path
						d="M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M7.79393474,3.19226965 C8.34621949,3.19226965 8.79393474,3.6399849 8.79393474,4.19226965 L8.79354796,8.17126965 L11.1301635,9.68880133 C11.5933484,9.98959716 11.7249908,10.608926 11.424195,11.0721109 L11.2197447,11.3869368 C10.9189489,11.8501217 10.2996201,11.9817641 9.8364351,11.6809683 L7.24056651,9.9977943 C6.77319329,9.91383502 6.41854796,9.50512646 6.41854796,9.01358605 L6.41854796,4.19226965 C6.41854796,3.6399849 6.86626321,3.19226965 7.41854796,3.19226965 L7.79393474,3.19226965 Z"
						id="Combined-Shape"
					/>
				</g>
			</svg>
		</div>
	);
}

export default Clock;
